import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useNavigate } from 'react-router-dom'
import { resetCategorias, setPublicacionesFiltradas } from '../../../slices/filterSlice'
import Publicacion from '../../publicaciones/Publicacion'
import { Filtros } from '../../reutilizables/filtros/Filtros'
import { buscarListaPorVendedor } from '../../servicios/listaVentaService'
import {
  buscarExposicion,
  buscarTodasOptimizado
} from '../../servicios/publicacionesService'
import ComponenteError from '../ComponenteError'
import styles from '../Publicaciones.module.css'

const Publicaciones = () => {
  const idVendedor = parseInt(localStorage.getItem('idUsuario'))
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [publicaciones, setPublicaciones] = useState([])
  const [error, setError] = useState(false)
  const [exposicion, setExposicion] = useState('')
  const [exposiciones, setExposiciones] = useState([])
  const [lista, setLista] = useState('')
  const [listas, setListas] = useState([])
  const [listasConDatos, setListasConDatos] = useState([])

  const { publicacionesFiltradas } = useSelector((state) => state.filters)

  const fetchData = async () => {
    const { data } = await buscarTodasOptimizado(0, idVendedor, 0, '')
    const listas = await buscarListaPorVendedor(idVendedor)
    const listaIds = new Set(data.map((p) => p.idListaVenta))
    const listasConDatos = listas.data.filter((l) => listaIds.has(l.idListaVenta))
    setListas(listasConDatos)
    setListasConDatos(listasConDatos)

    const exposicion = await buscarExposicion('')
    setExposiciones(exposicion.data)

    const publicaciones = data.map((pub) => {
      const listaMatch = listas.data.find((l) => l.idListaVenta === pub.idListaVenta)
      const porcDctoPublicacion = Number(pub.porcDctoPublicacion ?? 0)
      const porcDctoLista = Number(pub.porcDctoLista ?? 0)
      let porcDctoMostrar = 0
      let origenDescuento = 'ninguno'
      if (porcDctoPublicacion > 0) {
        porcDctoMostrar = porcDctoPublicacion
        origenDescuento = 'publicacion'
      } else if (porcDctoLista > 0) {
        porcDctoMostrar = porcDctoLista
        origenDescuento = 'lista'
      }

      return {
        ...pub,
        porcDctoMostrar,
        origenDescuento,
        publicacionExposicion:
          exposicion.data.find(
            (e) => e.idPublicacionExposicion === pub.idPublicacionExposicion
          )?.nombre || '',
        listaVenta: listaMatch?.nombre || ''
      }
    })
    setPublicaciones(publicaciones)
    setError(false)
  }

  useEffect(() => {
    fetchData()
  }, [idVendedor])

  useEffect(() => {
    let p = publicaciones
    if (exposicion !== '') {
      p = p.filter((publicacion) => publicacion.idPublicacionExposicion === exposicion)
    }
    if (lista !== '') {
      p = p.filter((publicacion) => publicacion.idListaVenta === lista)
    }
    if (listas.length > 0) {
      setListasConDatos(
        listas.filter((l) => p.some((p) => p.idListaVenta === l.idListaVenta))
      )
    }
    dispatch(setPublicacionesFiltradas(p))
  }, [exposicion, lista])

  const handleToggle = (event, publicacion, idPublicacion) => {
    navigate(`/Publicaciones/Administrar/${idPublicacion}`)
    window.scrollTo(0, 0)
  }

  const filtrarPorBusqueda = (valor) => {
    dispatch(resetCategorias())
    setExposicion('')
    setLista('')
    const filtradas = publicaciones.filter(({ titulo, idPublicacion }) => {
      return titulo.toLowerCase().includes(valor) || idPublicacion === Number(valor)
    })
    dispatch(setPublicacionesFiltradas(filtradas))
  }

  const filtrosFijos = [
    {
      titulo: 'Tipo de Exposición',
      value: exposicion,
      opciones: exposiciones.map((e) => ({
        label: e.nombre,
        valor: e.idPublicacionExposicion
      })),
      onChange: (v) => setExposicion(v)
    },
    {
      titulo: 'Listas',
      value: lista,
      opciones: listasConDatos.map((l) => ({ label: l.nombre, valor: l.idListaVenta })),
      onChange: (v) => setLista(v)
    }
  ]

  return (
    <div className={styles.layout}>
      {publicaciones.length > 0 && (
        <aside className={styles.filtros}>
          <Filtros
            publicaciones={publicaciones}
            filtrosFijos={filtrosFijos}
            mostrarFiltroPrecio={false}
            buscador={{
              onChange: (valor) => filtrarPorBusqueda(valor),
              placeholder: 'Buscar por titulo o id...'
            }}
          />
        </aside>
      )}

      <fieldset className={`fieldset ${styles.fieldset}`}>
        <div className={styles.headerPublicaciones}>
          <legend>Administrar Publicaciones</legend>
        </div>
        {publicacionesFiltradas.length !== 0 && (
          <>
            {error ? (
              <ComponenteError tipo="i" idAviso={11} key={1} />
            ) : (
              <>
                {publicacionesFiltradas.map((publicacion) => (
                  <div key={publicacion.idPublicacion} className={styles.publicacion}>
                    <Publicacion
                      vieneDeAdministrar={true}
                      onToggleClick={handleToggle}
                      publicacion={publicacion}
                    />
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {publicacionesFiltradas.length === 0 && (
          <ComponenteError tipo="i" idAviso={8} key={2} />
        )}
      </fieldset>
    </div>
  )
}

export default Publicaciones
